<template>
  <div>
    <div class="row align-items-center mb-3">
      <div class="col-4">
        <p class="mb-0 font-weight-bolder h5">Events:</p>
      </div>
      <div class="col-8 text-right">
        <holiday-list />
      </div>
    </div>
    <a-divider class="mb-3"/>
    <div class="row">
      <div class="col-12">
        <a-spin :spinning="loading">
          <div class="neo-tabs">
            <a-tabs :defaultActiveKey="selectedMonth" :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'" @change="handleMonthChange">
              <a-tab-pane tab="All Events" :key="undefined">
                <events-list :events="events" :rolesetting="rolesetting"/>
              </a-tab-pane>
              <a-tab-pane v-for="month in monthsOfYear" :tab="month.name" :key="month.value">
                <events-list :events="events" :rolesetting="rolesetting"/>
              </a-tab-pane>
            </a-tabs>
          </div>
        </a-spin>
      </div>
    </div>
    <add-calendar-event ref="calendarAddEvent" @created="handleEventCreated"/>
    <edit-calendar-event ref="calendarEditEvent" @edited="handleEventEdited"/>
    <single-calendar-event ref="calendarSingleEvent"/>
  </div>
</template>
<script>
import moment from 'moment'
import { find } from 'lodash'
import { mapState } from 'vuex'

import AddCalendarEvent from '@/components/calendar/Form/Add/index'
import EditCalendarEvent from '@/components/calendar/Form/Edit/index'
import SingleCalendarEvent from '@/components/calendar/Display/Single/index'
import EventsList from '@/components/calendar/Events/List/index'
import HolidayList from '@/components/calendar/Events/Holidays/index'

import { eventTypes, targetAudianceTypes, monthsOfYear } from '@/services/globaldata'

export default {
  name: 'Events',
  components: {
    AddCalendarEvent,
    EditCalendarEvent,
    SingleCalendarEvent,
    EventsList,
    HolidayList,
  },
  props: {
    rolesetting: { type: Object },
  },
  mounted: function() {
    this.getEvents()
    this.$eventBus.$on('calendarEventUpdated', this.getEvents)
  },
  data: function() {
    return {
      events: [],
      loading: false,
      eventTypes,
      targetAudianceTypes,
      monthsOfYear,
      dateFormat: 'LL',
      timeFormat: 'hh:mm a',
      selectedMonth: moment().format('MM'),
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    moment,
    getEvents: function () {
      this.loading = true
      this.$http.get('/api/calendar', {
        params: {
          month: this.selectedMonth,
        },
      }).then(({ data }) => {
        this.events = data.data
        this.loading = false
      })
    },
    handleMonthChange(month) {
      this.selectedMonth = month
      this.getEvents()
    },
    getEventType(eventType) {
      return find(this.eventTypes, { value: eventType }).name
    },
    getEventRange(startDate, endDate, endTime) {
      const startD = moment(startDate)
      let endD = moment(endDate)
      if (!endTime) {
        endD = moment(endDate + ' ' + '24:00:00')
      }
      const range = endD.diff(startD, 'days')

      if (range > 1) {
        return range + ' days'
      }
      return ''
    },
    handleEventCreated() {
      this.getEvents()
    },
    handleEventEdited() {
      this.getEvents()
    },
  },
}
</script>
